module.exports = __webpack_public_path__ + "img/img10.0be3bf7e.svg";